import "./style.scss"
import React, { Component } from 'react'
import { Icon, Dropdown, Menu, Button } from "antd";
import { map } from 'lodash'
import Flag from "react-flags";
import LanguageIcon from './flag'

import logic from './logic'
import i18n from '~/i18n'
const __ = i18n.t.bind(i18n);


export {
  LanguageIcon
}

@logic
export default class LanguageSelector extends Component {
  handleMenuClick = (e) => {
    const { changeLanguage } = this.props.actions;
    const { key, ...others } = e;
    changeLanguage(key);

  };
  render() {
    const { languages, language, size, visible } = this.props;

    if(!visible) {
      return null;
    }

    const menu = (
      <Menu style={{width: 240}} onClick={this.handleMenuClick}>
        {map(languages, (lng) => {
          return <Menu.Item key={ lng.value }>
            <span style={{visibility: language.value === lng.value ? 'visible': 'hidden'}}>✓ </span>
            { lng.label }
          </Menu.Item>
        }) }
      </Menu>
    );
    return (
      <Dropdown overlay={menu} trigger={['click']} placement="topLeft">
        <Button size={size || "large"} type="primary" className="language-selector">
          <Flag
            name={ language.country }
            format="png"
            shiny={true}
            pngSize={32}
            width={16}
            height={16}
            basePath={"/assets/img/flags"}
          />
          <span>{ __('Language') }: { language.label } </span>
        </Button>
      </Dropdown>
    )
  }
}
